import React from 'react';
import Button from 'material-ui/Button';
import Dialog from 'material-ui/Dialog';
import DialogActions from 'material-ui/Dialog/DialogActions';
import DialogContent from 'material-ui/Dialog/DialogContent';
import DialogContentText from 'material-ui/Dialog/DialogContentText';
import DialogTitle from 'material-ui/Dialog/DialogTitle';
import { connect } from 'react-redux';
import flow from 'lodash/flow'
import {
  getConfirmationMessage,
  getConfirmationNegativeAction,
  getConfirmationPositiveAction,
  getConfirmationTitle,
  isConfirmationDialogOpen
} from '../selectors/confirmationDialog';
import { closeConfirmationDialog } from '../actions';

const ConfirmationDialog = (props) => {
  const { open, handleClose, message, title, positiveAction, negativeAction } = props
  const onClose = () => {
    negativeAction && negativeAction()
    handleClose()
  }
  const onOk = () => {
    positiveAction()
    handleClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={onOk} color="primary" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}


const mapStateToProps = (state) => ({
  open: isConfirmationDialogOpen(state),
  message: getConfirmationMessage(state),
  title: getConfirmationTitle(state),
  positiveAction: getConfirmationPositiveAction(state),
  negativeAction: getConfirmationNegativeAction(state)
});

const mapDispatchToProps = (dispatch) => {
  return {
      handleClose: () => {
          dispatch(closeConfirmationDialog());
      },
  }
};


export default flow([
  connect(mapStateToProps, mapDispatchToProps)
])(ConfirmationDialog);




// WEBPACK FOOTER //
// ./src/components/ConfirmationDialog.js